import { apiSlice } from "./ApiSlice";

export const ChatBotApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    
    PostStartChatBot: builder.mutation({
      query: (data) => ({
        url: "/api/ClinicProfile/start",
        method: "POST",
        body: data,
      }),
      // invalidate conversation list if new one is created
      invalidatesTags: ["Conversation"],
    }),


    PostSendChatBotMessage: builder.mutation({
      query: (data) => ({
        url: "/api/ClinicProfile/send",
        method: "POST",
        body: data,
      }),
      // after sending, invalidate messages to auto-refresh
      invalidatesTags: (result, error, arg) => [
        { type: "Messages", id: arg.ConversationID },
      ],
    }),

 
    PostEndChatBot: builder.mutation({
      query: (data) => ({
        url: "/api/ClinicProfile/end",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Conversation"],
    }),

  
    GetChatBotMessages: builder.query({
      query: (conversationId) => ({
        url: `/api/ClinicProfile/messages/${conversationId}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Messages", id }],
    }),

   
    getChatBotAllConversations: builder.query({
      query: () => ({
        url: "/api/ClinicProfile/all-conversations",
        method: "GET",
      }),
      providesTags: ["Conversation"],
    }),
  }),
});

export const {
  usePostStartChatBotMutation,
  usePostSendChatBotMessageMutation,
  usePostEndChatBotMutation,
  useLazyGetChatBotMessagesQuery,
  useGetChatBotAllConversationsQuery,
} = ChatBotApiSlice;
